import { render } from "./UpdateRelocation.vue?vue&type=template&id=80df8068&scoped=true&ts=true"
import script from "./UpdateRelocation.vue?vue&type=script&lang=ts"
export * from "./UpdateRelocation.vue?vue&type=script&lang=ts"

import "./UpdateRelocation.vue?vue&type=style&index=0&id=80df8068&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80df8068"]])

export default __exports__